module.exports = __webpack_public_path__ + "static/media/1.9021a891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16016/1.jpg
// module id = 508
// module chunks = 0